import React from 'react';
import { Row, Col, Icon } from 'rsuite';


export class ChatMeTwitter extends React.Component {
    render() {
        return (
            <Row>
                <Col>
                    <div className="chat-me-twitter">
                        Have questions or suggestion?
                    </div>
                    <a href="https://twitter.com/VismaraIlyich" target="_blank">Chat me on <Icon icon="twitter" /></a>
                </Col>
            </Row>
        )
    }
}